<template>
  <table class="first">
    <tbody>
      <tr>
        <td colspan="3" class="black label">
          {{ currentStage.name }}
        </td>
      </tr>
      <tr v-for="result in liveResults.slice(0, staticRows)" :key="result.number" class="static-row">
        <td class="black" style="min-width: 3rem">{{ result.pos }}</td>
        <td class="black name">
          <span class="number">{{ result.number }}</span>
          <country-flag :country="getFlag(result.driver.nationality)" size="small" class="flag" />
          {{ result.driver.surname }}
        </td>
        <td class="black">{{ result.result | formatResult(resultPrecision) }}</td>
      </tr>
      <tr
        v-for="result in liveResults.slice(staticRows + dynamicRows * page, staticRows + dynamicRows * (page + 1))"
        :key="result.number"
      >
        <td class="black">{{ result.pos }}</td>
        <td class="black name">
          <span class="number">{{ result.number }}</span>
          <country-flag :country="getFlag(result.driver.nationality)" size="small" class="flag" />
          {{ result.driver.surname }}
        </td>
        <td class="black">{{ result.result | formatResult(resultPrecision) }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import CountryFlag from "vue-country-flag"
import axios from "axios"

export default {
  name: "LiveTableSolo",
  data: () => ({
    page: 0,
    pageInterval: null,
    timePerPage: 5,
    staticRows: 10,
    dynamicRows: 10,
    liveConfig: {},
  }),
  props: {
    liveResults: Array,
    currentStage: Object,
    resultPrecision: Number,
    pilot: Boolean,
  },
  components: {
    CountryFlag,
  },
  filters: {
    formatResult: function (result, resultPrecision) {
      if (isNaN(result)) return result
      if (result === null) return "-"

      const ms = result % 1000
      const sec = ((result - ms) / 1000) % 60
      const min = (((result - ms) / 1000 - sec) / 60) % 60
      const hrs = (((result - ms) / 1000 - sec) / 60 - min) / 60
      const format = (input) => String(input).padStart(2, "0")
      const formatMs = (ms) => String(ms).padStart(3, "0").slice(0, resultPrecision)
      if (hrs > 0) return `${hrs}:${format(min)}:${format(sec)},${formatMs(ms)}`

      return `${format(min)}:${format(sec)},${formatMs(ms)}`
    },
  },
  mounted() {
    axios.get("/liveConfig.json").then((response) => {
      const data = response.data
      this.liveConfig = data.liveConfig
      if (this.liveConfig.tableSolo.timePerPage) this.timePerPage = this.liveConfig.tableSolo.timePerPage
      if (this.liveConfig.tableSolo.staticRows) this.staticRows = this.liveConfig.tableSolo.staticRows
      if (this.liveConfig.tableSolo.dynamicRows) this.dynamicRows = this.liveConfig.tableSolo.dynamicRows
      this.startPageInterval()
    })
    this.startPageInterval()
  },
  methods: {
    startPageInterval: function () {
      this.page = 0
      if (this.pageInterval) clearInterval(this.pageInterval)
      this.pageInterval = setInterval(() => {
        this.page++
        if (this.liveResults.length <= this.staticRows + this.page * this.dynamicRows) this.page = 0
      }, this.timePerPage * 1000)
    },
    getFlag: function (value) {
      if (value === "KOS") return "xk"
      return value
    },
  },
  computed: {},
}
</script>

<style lang="scss" scoped>
table {
  table-layout: auto !important;
  width: auto !important;

  &.first {
    width: auto;

    td {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
      border-collapse: collapse;
      border: 5px solid #00ff00;
      font-size: 16px;
      text-align: left;
      &.name {
        min-width: 12rem;
        .number {
          text-align: center;
          width: 1.3rem;
          font-weight: normal;
          font-size: 95%;
          position: fixed;
        }
      }
      &.black {
        &:first-child,
        &:last-child,
        time {
          padding: 6px 8px 6px 8px;
          text-align: center;
        }
      }
    }

    tr.static-row td {
      font-weight: bold;
    }
  }

  .label {
    font-weight: bold;
    font-size: 17px;
    padding: 1px 1px 1px 1px;
  }

  .black {
    text-align: left;
    background-image: url("/img/live/black_box.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    background-color: #262626;
    color: #ffffff;
    padding: 6px;
  }

  .flag {
    flex-shrink: 0;
    margin: -14px -22px -14px 2px;
  }
}
</style>
